import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {errorRoute} from './error/error.route';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {
  ErrorComponent,
  TopBarComponent,
  FooterComponent,
  SideNavBarComponent,
  OutsideLayoutComponent
} from './';
import {MatExpansionModule} from '@angular/material/expansion';
import {SideNavBarService} from './side-nav-bar/side-nav-bar.service';

const LAYOUT_ROUTES = [
  ...errorRoute
];

@NgModule({
  imports: [
    RouterModule.forRoot(LAYOUT_ROUTES, { relativeLinkResolution: 'legacy' }),
    SharedModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatExpansionModule
  ],
  declarations: [
    ErrorComponent,
    TopBarComponent,
    FooterComponent,
    SideNavBarComponent,
    OutsideLayoutComponent
  ],
  exports: [
    RouterModule
  ],
  providers: [
    SideNavBarService
  ]
})

export class LayoutsModule {
}
